import { Controller } from "@hotwired/stimulus"

// Shows a full-screen loading overlay while the FBR upload is in progress.
// The overlay is removed automatically when Turbo loads the result page.
export default class extends Controller {
  showLoader() {
    const overlay = document.createElement("div")
    overlay.id = "fbr-upload-overlay"
    overlay.innerHTML = `
      <div class="flex flex-col items-center gap-5">
        <div class="relative flex size-20 items-center justify-center">
          <span class="absolute inline-flex size-full animate-ping rounded-full bg-white opacity-20"></span>
          <div class="relative flex size-16 items-center justify-center rounded-full bg-white/20 backdrop-blur">
            <span class="material-symbols-outlined text-white text-4xl" style="font-variation-settings:'FILL' 1">cloud_upload</span>
          </div>
        </div>
        <div class="text-center">
          <p class="text-white text-lg font-bold">Uploading to FBR</p>
          <p class="text-white/70 text-sm mt-1">Please wait, do not close this page</p>
        </div>
        <div class="flex gap-1.5">
          <span class="size-2 rounded-full bg-white/60 animate-bounce" style="animation-delay:0ms"></span>
          <span class="size-2 rounded-full bg-white/60 animate-bounce" style="animation-delay:150ms"></span>
          <span class="size-2 rounded-full bg-white/60 animate-bounce" style="animation-delay:300ms"></span>
        </div>
      </div>
    `
    Object.assign(overlay.style, {
      position:       "fixed",
      inset:          "0",
      zIndex:         "9999",
      display:        "flex",
      alignItems:     "center",
      justifyContent: "center",
      background:     "rgba(26,107,60,0.92)",
      backdropFilter: "blur(8px)",
      WebkitBackdropFilter: "blur(8px)"
    })

    document.body.appendChild(overlay)

    // Remove overlay after Turbo finishes rendering the result page
    document.addEventListener("turbo:load", () => overlay.remove(), { once: true })
  }
}
